<template>
  <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <div class="countryList" v-show="seetown">
        <div class="country">
          <span>行政区划：</span>
        </div>
        <div class="country">
          <span @click="setAllCheck()" :class="{ countryon: all }">全部</span>
        </div>
        <div class="country" v-for="(item,index) in xingZhenQuHuaDatas" :key="index">
          <span
            @click="setListCheck(index, item)"
            :class="{ countryon: item.check }"
          >{{item.adcdName}}</span>
        </div>
      </div>
      <div class="skt" ref="skt">
        <div class="select">
          <span v-show="qunZhuIsShow" class="xzqh">群组:</span>
          <div v-show="qunZhuIsShow" class="selcountry">
            <el-select
              v-model="query.groupId"
              clearable
              filterable
              placeholder="请选择群组"
              @change="Global.emptyQuery(query.groupId,searchLoadTableData)"
            >
              <el-option
                v-for="item in group"
                :key="item.value"
                :label="item.groupName"
                :value="item.groupId"
              ></el-option>
            </el-select>
          </div>
          <span v-if="cunIsShow" class="xzqh">村名:</span>
          <div v-if="cunIsShow" class="selcountry">
            <el-select
              v-model="query.cunData"
              clearable
              filterable
              placeholder="请选择村"
              @change="Global.emptyQuery(query.cunData,searchLoadTableData)"
            >
              <el-option
                v-for="item in cunDatas"
                :key="item.value"
                :label="item.adcdName"
                :value="item.adcdCode"
              ></el-option>
            </el-select>
          </div>
          <span class="xzqh">姓名/手机:</span>
          <div class="selcountry">
            <el-input
              v-model="query.personName"
              clearable
              placeholder="请输入姓名/手机"
              @change="Global.emptyQuery(query.personName,searchLoadTableData)"
            ></el-input>
          </div>
          <!-- <span class="xzqh">岗位/职务:</span>
          <div class="selcountry">
            <el-input
              v-model="query.personPosition"
              clearable
              placeholder="请输入岗位/职务"
              @change="Global.emptyQuery(query.personPosition,searchLoadTableData)"
            ></el-input>
          </div> -->
          <span class="xzqh">部门/行政区划:</span>
          <div class="selcountry">
            <el-cascader
            v-model="query.deptId"
            separator="-"
            :options="mutiRanksAdcd"
            :props="{ expandTrigger: 'hover',value:'deptId',label:'deptName' }"
            change-on-select
            filterable
            clearable
            placeholder="请选择部门/行政区划"
            @change="handleEmptyQuery"
          >
          </el-cascader>
          </div>
           <!-- <span class="xzqh">行政区划:</span>
          <div class="selcountry">
            <el-select v-model="deptId" placeholder="部门/行政区" filterable clearable>
            <el-option
              v-for="item in dept"
              :key="item.value"
              :label="item.deptName"
              :value="item.deptId"
            ></el-option>
          </el-select>
          </div> -->
          <span id="search" @click="searchLoadTableData">查询</span>
          <!-- <span v-if="allowsPerm.delete" id="del" v-show="operationBtnIsShow"  @click="delDialog">
            <span class="del-icon"></span>删除
          </span>
          <span v-if="allowsPerm.update" id="edit" v-show="operationBtnIsShow" @click="editDialog">
            <span class="edit-icon"></span>编辑
          </span>
          <span v-if="allowsPerm.insert" id="add" v-show="operationBtnIsShow" @click="addDialog">
            <span class="add-icon"></span>新增
          </span> -->
        <div class="handle-container">
            <div class="import" v-if="allowsPerm.insert" v-show="operationBtnIsShow">
              <el-upload
                  :action="`${uploadUrl}/warninfo/import_message_person_list`"
                  :data ="{}"
                  :headers="myHeaders"
                  :file-list="fileList"
                   accept=".xls, .xlsx"
                  :before-upload="uploadBefore"
                  :on-success="uploadSuccess"
                  :on-error="uploadError"
                  :show-file-list="false"
                >
                 <el-button size="medium" type="primary" icon="el-icon-upload">导入</el-button>
              </el-upload>
              </div>
            <div class="export" @click= exportData><el-button size="medium" type="success" icon="el-icon-upload2">导出</el-button></div>
            <div class="download" @click="downloadData"><el-button size="medium" type="info" icon="el-icon-download">下载模板</el-button></div>
             <div class="btn-handle">
               <span v-if="allowsPerm.delete" id="del" v-show="operationBtnIsShow"  @click="delDialog">
                <span class="del-icon"></span>删除
              </span>
              <span v-if="allowsPerm.update" id="edit" v-show="operationBtnIsShow" @click="editDialog">
                <span class="edit-icon"></span>编辑
              </span>
              <span v-if="allowsPerm.insert" id="add" v-show="operationBtnIsShow" @click="addDialog">
                <span class="add-icon"></span>新增
              </span>
            </div>
          </div>
        </div>
        <div class="tablebox">
          <div ref="fzxxtable" class="fzxxtable">
            <el-table
                  v-loading="loading"
                  ref="multipleTable"
                  @row-click="clickRow"
                  border
                  :data="tableData"
                  :max-height="height"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column type="selection" min-width="40" align="center"></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    width="60"
                    type="index"
                    label="序号"
                  >
                  <template slot-scope="scope">
                      <span>{{(query.pageIndex - 1) * query.pageSize + scope.$index + 1}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="adcdName"
                    label="部门/行政区划"
                    min-width="60"
                    align="left"
                    header-align="left"
                  ></el-table-column>
                  <el-table-column
                    prop="groupName"
                    label="群组"
                    min-width="60"
                    align="left"
                    header-align="left"
                  ></el-table-column>
                  <el-table-column
                    prop="personName"
                    label="姓名"
                    min-width="60"
                    align="left"
                    header-align="left"
                  ></el-table-column>
                  <el-table-column
                    prop="personPhone"
                    label="手机"
                    min-width="60"
                    align="left"
                    header-align="left"
                  ></el-table-column>
                  <el-table-column
                    prop="personPosition"
                    label="岗位/职务"
                    min-width="60"
                    align="left"
                    header-align="left"
                  ></el-table-column>
                  <el-table-column
                    prop="remark"
                    label="备注"
                    min-width="100"
                    align="left"
                    header-align="left"
                  ></el-table-column>
                </el-table>
          </div>
        </div>
        <div ref="pager">
          <pager
            @current-change="onCurrentChange"
            @size-change="onSizeChange"
            :pageIndex="query.pageIndex"
            :pageSize="query.pageSize"
            :total="query.total"
          ></pager>
        </div>
      </div>
    </div>
    <el-dialog :title="saveFormStatus + '责任人'" class="abow_dialog" :visible.sync="saveFormIsShow" :close-on-click-modal="false">
      <el-form ref="groupForm" :model="form" :rules="rules" label-width="170px" label-height="40px">
        <el-form-item label="群组:" prop="groupId">
          <el-select v-model="form.groupId" placeholder="群组" filterable clearable>
            <el-option
              v-for="item in group"
              :key="item.value"
              :label="item.groupName"
              :value="item.groupId"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="部门/行政区:" prop="deptId">
          <el-select v-model="form.deptId" placeholder="部门/行政区" filterable clearable>
            <el-option
              v-for="item in dept"
              :key="item.value"
              :label="item.deptName"
              :value="item.deptId"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="行政区划:" prop="deptId">
          <el-cascader
            v-model="form.deptId"
            separator="-"
            :options="mutiRanksAdcd"
            :props="{ expandTrigger: 'hover',value:'deptId',label:'deptName' }"
            change-on-select
            filterable
            clearable
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="姓名:" prop="personName">
          <el-input v-model="form.personName"></el-input>
        </el-form-item>
        <el-form-item label="手机:" prop="personPhone">
          <el-input v-model="form.personPhone"></el-input>
        </el-form-item>
        <el-form-item label="岗位/职务:" prop="personPosition">
          <el-input v-model="form.personPosition"></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item label="id" style="display:none;">
          <el-input v-model="form.personId"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveFormIsShow = false">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 异常导入错误信息详情 -->
      <el-dialog
        :title="'异常' + dialogTitle + '列表'"
        class="pop-error-container"
        :visible.sync="dialogShowError"
        :close-on-click-modal="false"
        width="50%"
      >
        <div class="pop-content-body">
          <div class="table-list">
            <div class="main" ref="uploadErrorList">
              <el-table
                :data="errorTableData"
                border
                stripe
                :header-cell-style="{ background: '#F5F7FA' }"
                :max-height="errorTableHeight"
                style="width: 100%"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  label="序号"
                  type="index"
                  width="80"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="desc"
                  :show-overflow-tooltip="true"
                  label="导入异常问题"
                  min-width="80"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-dialog>
  </div>
</template>
<script>
import Pager from '@/components/Pager'
import warnTypes from '@/store/types/warningcenter'
import config from '@/config'
import { getToken } from '@/utils/auth'
let token = getToken()
export default {
  components: {
    Pager
  },
  data () {
    return {
      myHeaders: { Authorization: token, accept: 'application/jsons' }, // 获取导入所需token
      fileList: [],
      // downloadUrl: 'http://172.21.90.179:29823', // 导入下载地址
      dialogTitle: '导入问题',
      uploadUrl: config.ApiYJ,
      errorTableData: [],
      errorTableHeight: '100',
      dialogShowError: false,
      operationBtnIsShow: false,
      seetown: true,
      height: 10,
      all: true,
      cunIsShow: false,
      qunZhuIsShow: false,
      loading: false,
      saveFormStatus: '新增',
      tableRowSelecteds: [],
      activeName: 'second',
      saveFormIsShow: false,
      tableData: [],
      xingZhenQuHuaDatas: [],
      cunDatas: [],
      group: [],
      dept: [],
      mutiRanksAdcd: [],
      query: {
        pageIndex: 1,
        pageSize: 20,
        total: 0,
        adcdList: [],
        cunData: '',
        groupId: '',
        deptId: []
      },
      form: {},
      rules: {
        groupId: [{ required: true, message: '请选择群组', trigger: 'change' }],
        deptId: [
          { required: true, message: '请选择部门/行政区', trigger: 'change' }
        ],
        personName: [{ required: true, validator: this.Global.chnName, trigger: 'blur' }],
        personPhone: [
          { required: true, validator: this.Global.checkIsCellphoneNumber, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onSizeChange (size) {
      this.query.pageIndex = 1
      this.query.pageSize = size
      this.loadTableData()
    },
    onCurrentChange (page) {
      this.query.pageIndex = page
      this.loadTableData()
    },
    searchLoadTableData () {
      this.query.pageIndex = 1 // 重置页码
      this.loadTableData()
    },
    handleEmptyQuery () { // 清空为数组时
      if (this.query.deptId !== undefined && this.query.deptId.length === 0 && Array.isArray(this.query.deptId)) {
        this.query.deptId = ''
        this.searchLoadTableData()
      }
    },
    loadTableData () {
      let adcdList = Object.assign([], this.query.adcdList)
      // this.query.adcdList = [
      //   { AdcdCode: this.query.groupId, AdcdLevel: '5' } // 部门人员
      // ]
      // if (this.query.cunData !== '' && this.query.cunData !== undefined) {
      //   adcdList = [{ AdcdCode: this.query.cunData, AdcdLevel: '1' }]
      // }
      if (this.query.groupId !== '' && this.query.groupId !== undefined) { // 群组为空时
        adcdList = [{ AdcdCode: this.query.groupId, AdcdLevel: '5' }]
      }
      // 行政区划查询
      if (this.query.deptId !== undefined && this.query.deptId.length > 0 && Array.isArray(this.query.deptId)) { // 行政区划有值且数组
        let adcdidLength = this.query.deptId.length
        this.query.deptId = this.query.deptId[adcdidLength - 1]
      } else if (this.query.deptId !== undefined && this.query.deptId.length === 0 && Array.isArray(this.query.deptId)) {
        this.query.deptId = ''
      }
      // console.log(this.query.adcdList)
      this.loading = true
      this.seetown = false
      this.operationBtnIsShow = true
      this.qunZhuIsShow = true
      this.$store
        .dispatch(warnTypes.GET_PERSONLIST, {
          personName: this.query.personName,
          adcdList: adcdList,
          position: this.query.personPosition,
          adcdCode: this.query.deptId,
          pageIndex: this.query.pageIndex,
          pageSize: this.query.pageSize
        })
        .then(data => {
          this.tableData = data.results
          this.query.total = data.total
          this.loading = false
        })
    },
    getGroups () {
      this.$store.dispatch(warnTypes.GET_GROUPLIST).then(data => {
        this.group = data
      })
    },
    getDepts () {
      this.$store.dispatch(warnTypes.GET_DEPTLIST).then(data => {
        this.dept = data
      })
    },
    // 获取部门及行政区划
    getDeptAdcdList () {
      this.$store.dispatch(warnTypes.GET_DEPT_ADCDLIST).then(data => {
        this.mutiRanksAdcd = data
      })
    },
    getAdcdid (val, dataSource) { // 部门、行政区划级联选择器递归遍历
      let returnArray = []
      if (val !== undefined && val !== '' && dataSource !== undefined && dataSource !== null && dataSource.length > 0) {
        for (let index = 0; index < dataSource.length; index++) {
          const element = dataSource[index]
          if (element.deptId === val) {
            returnArray.unshift(element.deptId)
            break
          } else {
            returnArray = this.getAdcdid(val, element['children'])
            if (returnArray.length > 0) {
              returnArray.unshift(element.deptId)
              break
            }
          }
        }
      }
      return returnArray
    },
    handleClick (tab, event) {
      if (tab.label === '部门人员') {
        this.seetown = false
        this.query.pageIndex = 1
        this.query.pageSize = 20
        this.operationBtnIsShow = true
        this.qunZhuIsShow = true
      } else {
        this.seetown = true
        this.query.pageIndex = 1
        this.query.pageSize = 20
        this.qunZhuIsShow = false
        this.operationBtnIsShow = false
        this.query.groupId = ''
        this.$nextTick(() => {
          let contentDiv = document.getElementsByClassName('content')
          let countryListDiv = document.getElementsByClassName('countryList')
          this.$refs['skt'].style.height = contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45 + 'px'
        })
      }
      if (this.all) {
        this.setAllAdcdListInit()
      }
      this.loadTableData()
    },
    setAllCheck () {
      this.all = true
      this.setAllAdcdListInit()
      this.xingZhenQuHuaDatas.forEach(element => {
        element.check = false
      })
      this.cunIsShow = false
      this.query.cunData = ''
      this.cunDatas = []
      this.loadTableData()
    },
    setAllAdcdListInit () {
      if (this.activeName === 'first') {
        this.query.adcdList = [
          { AdcdCode: '330185000000000', AdcdLevel: '3' } // 基层防汛责任人
        ]
      } else {
        this.query.adcdList = [
          { AdcdCode: '0', AdcdLevel: '5' } // 部门人员
        ]
      }
    },
    setListCheck (index, itemData) {
      this.all = false
      this.query.adcdList = this.query.adcdList.filter(item => {
        return item.AdcdCode !== '330185000000000' && item.AdcdCode !== '0'
      })
      if (itemData.check) {
        itemData.check = false
        let removeIndex = this.query.adcdList.findIndex(item => {
          return item.AdcdCode === itemData.adcdCode
        })
        this.query.adcdList.splice(removeIndex, 1)
      } else {
        itemData.check = true
        this.query.adcdList.push({ AdcdCode: itemData.adcdCode, AdcdLevel: '2' })
      }
      if (
        this.query.adcdList.length === 0 ||
        this.query.adcdList.length === this.xingZhenQuHuaDatas.length
      ) {
        this.setAllCheck()
      } else {
        if (this.query.adcdList.length === 1) {
          this.cunIsShow = true
          this.loadCunDatas(this.query.adcdList[0].AdcdCode)
        } else {
          this.cunIsShow = false
          this.query.cunData = ''
          this.cunDatas = []
        }
        this.loadTableData()
      }
    },
    loadCunDatas (val) {
      this.$store
        .dispatch(warnTypes.GET_NEXTADCDLIST, {
          adcdLevel: 4,
          adcdCode: val
        })
        .then(data => {
          this.cunDatas = data
        })
    },
    addDialog () {
      this.saveFormStatus = '新增'
      this.form = {}
      this.saveFormIsShow = true
      this.Global.clearValidate(this, 'groupForm')
    },
    editDialog () {
      this.saveFormStatus = '编辑'
      if (this.tableRowSelecteds.length === 1) {
        this.form = Object.assign({}, this.tableRowSelecteds[0])
        // this.$set(this.form, 'deptId', this.form.adcdCode)
        this.$set(this.form, 'deptId', this.getAdcdid(this.tableRowSelecteds[0].adcdCode, this.mutiRanksAdcd))
        let groupItems = this.group.filter(item => {
          return item.groupName === this.form.groupName
        })
        this.$set(this.form, 'groupId', groupItems[0].groupId)
        this.Global.clearValidate(this, 'groupForm')
        this.saveFormIsShow = true
      } else {
        this.$alert('必需只能选择一条数据', '提示')
      }
    },
    delDialog () {
      if (this.tableRowSelecteds.length < 1) {
        this.$alert('必需选择数据', '提示')
      } else {
        let delIds = [] // 清空数组
        this.tableRowSelecteds.forEach(item => {
          delIds.push(item.personId)
        })
        this.$confirm(`确定要删除已选择的数据 ?`, '确认')
          .then(() => {
            this.loading = true
            this.$store
              .dispatch(warnTypes.DELETE_PERSONINFOGROUP, {
                ids: delIds.join(',')
              })
              .then(() => {
                this.loading = false
                this.tableRowSelecteds = []
                this.loadTableData()
                this.$notify.success({
                  title: '成功',
                  message: '删除数据成功.'
                })
              })
              .catch(() => {
                this.loading = false
              })
          })
          .catch(() => {})
      }
    },
    save () {
      this.$refs['groupForm'].validate(valid => {
        if (valid) {
          this.loading = true
          if (this.form.deptId !== undefined && this.form.deptId.length > 0) {
            let adcdidLength = this.form.deptId.length
            this.form.deptId = this.form.deptId[adcdidLength - 1]
          }
          this.$store
            .dispatch(warnTypes.SAVE_PERSONINFO, this.form)
            .then(data => {
              this.loading = false
              this.saveFormIsShow = false
              this.form = {}
              this.$notify.success({ title: '成功', message: '保存成功。' })
              this.loadTableData()
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    getXingZhenQuHuaDatas () {
      this.$store
        .dispatch(warnTypes.GET_NEXTADCDLIST, {
          adcdLevel: '3'
        })
        .then(data => {
          this.xingZhenQuHuaDatas = data
          this.xingZhenQuHuaDatas.forEach(element => {
            element.check = false
          })
        })
    },
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    handleSelectionChange (val) {
      this.tableRowSelecteds = val
    },
    downloadData () { // 下载
      // window.open(
      //   `${config.ApiYJ}/导出/Template/预警人员导入模板.xls`
      // )
      let adcdList = Object.assign([], this.query.adcdList)
      if (this.query.groupId !== '' && this.query.groupId !== undefined) {
        adcdList = [{ AdcdCode: this.query.groupId, AdcdLevel: '5' }]
      }
      this.$store
        .dispatch(warnTypes.EXPORT_TEMPLATE_PERSONLIST, {
          personName: this.query.personName,
          adcdCode: this.query.deptId,
          adcdList: adcdList,
          position: this.query.personPosition
        })
        .then(data => {
          window.open(`${config.ApiYJ}${data.data}`)
          this.loading = false
        })
    },
    importData () {},
    exportData () { // 导出
      let adcdList = Object.assign([], this.query.adcdList)
      if (this.query.groupId !== '' && this.query.groupId !== undefined) {
        adcdList = [{ AdcdCode: this.query.groupId, AdcdLevel: '5' }]
      }
      // this.seetown = false
      // this.operationBtnIsShow = true
      // this.qunZhuIsShow = true
      this.$store
        .dispatch(warnTypes.EXPORT_PERSONLIST, {
          personName: this.query.personName,
          adcdList: adcdList,
          adcdCode: this.query.deptId,
          position: this.query.personPosition,
          pageIndex: this.query.pageIndex,
          pageSize: this.query.pageSize
        })
        .then(data => {
          window.open(`${config.ApiYJ}${data.data}`)
          this.loading = false
        })
    },
    uploadBefore (file) {
      this.loading = true
    },
    uploadSuccess (response, file, fileList) {
      this.loading = false
      if (response.result !== 'Failed') {
        this.$notify.success({ title: '成功', message: '导入成功' })
        this.loadTableData()
      } else {
        this.$notify.error({ title: '失败', message: '导入失败', duration: 0 })
        this.dialogShowError = true
        response.data.forEach(el => {
          return this.errorTableData.push({ desc: el })
        })
        this.$nextTick(() => {
          let errorTableElement = this.$refs.uploadErrorList
          this.errorTableHeight = errorTableElement.offsetHeight
        })
      }
    },
    // eslint-disable-next-line handle-callback-err
    uploadError (err, file, fileList) {
      this.loading = false
      this.$notify.error({ title: '失败', message: '导入失败' })
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
    // this.loadTableData()
    this.getDepts()
    this.getDeptAdcdList()
    this.setAllCheck()
    this.getGroups()
    this.getXingZhenQuHuaDatas()
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', {
          name: this.$route.meta,
          type: this.$route.name
        })
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('skt')
      this.height = contentDiv[0].offsetHeight - 120
    })
  }
}
</script>
<style lang="less" src="@/assets/warningcenter.less" scoped></style>
<style scoped>
body {
  background-color: #f0f2f6;
  margin: 0;
  padding: 0 0 10px 0;
}
.countryList {
  /* width: 100%; */
  height: 62px;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
}
.country {
  float: left;
  font-family: Microsoft YaHei UI;
  font-size: 15px;
  text-align: center;
  margin-top: 20px;
  margin-left: 0.5%;
  cursor: pointer;
}
.countryon {
  border-radius: 15px;
  background-color: #fda72c;
  color: #ffffff;
}
.country span {
  padding: 4px 15px;
}
.scence >>> .el-dialog__body {
  height: 70%;
  left: 0;
  top: 54px;
  bottom: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
.scence >>> .el-dialog {
  margin: 0 auto !important;
}
.scence >>> .el-form-item {
  margin-left: 1%;
  width: 44% !important;
}
.scence >>> .abow_dialog .el-input--suffix .el-input__inner {
  padding-right: 66px !important;
}
.scence >>> .selcountry {
  width: 180px;
}
.skt {
  height: 100%;
  margin-top: 0;
  position: relative;
}
/* 导入导出下载样式 */
.handle-container {
  position: absolute;
  right: 0;
  display: flex;
  justify-content: space-around;
}
.btn-handle {
  margin-left: 0.3rem !important;
}
.handle-container div {
  margin-right: 0.3rem;
}
.handle-container div.download {
  margin-left: 0.3rem;
  margin-top: 0.1rem;
}
.handle-container div.export {
  margin-top: 0.1rem;
}
.handle-container div.import {
  margin-top: 0.1rem;
}
.handle-container .import button{
  font-size: 0.5rem;
  font-weight: 500;
  height: 38px;
}
.handle-container .export button{
  font-size: 0.5rem;
  font-weight: 500;
  height: 38px;
}
.handle-container .download button{
  font-size: 0.5rem;
  font-weight: 500;
  height: 38px;
}
</style>
<style lang="less" scoped>
   .pop-error-container {
     margin-top: 15vh;
      /deep/ .el-dialog {
        .el-dialog__header {
          background: #217ff4;
          background-image: url("~@/assets/monitorimg/opentitle.png");
          background-repeat: no-repeat;
          background-position: 18px 28px;
          background-size: 370px 17px;
          .el-dialog__title {
            color: #ffffff;
            margin-left: 35px;
          }
          .el-dialog__headerbtn {
            .el-dialog__close {
              color: #ffffff;
            }
          }
        }
        .el-dialog__body {
          width: 100%;
          height: 100%;
          padding: 0 15px;
          padding-top: 15px;
          .pop-content-body {
            width: 100%;
            height: 475px;
            padding-bottom: 20px;
            .table-list {
              width: 100%;
              height: 100%;
              .main {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
</style>
